import { render } from "./AllUsersView.vue?vue&type=template&id=a61265b2"
import script from "./AllUsersView.vue?vue&type=script&lang=js"
export * from "./AllUsersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__